import React from 'react';
import './loader.scss';
import { CircularProgress } from '@mui/material';

const Loading = props => {
  const { isLoading } = props;
  return (
    <>
      {isLoading ? (
        <>
          {!props?.noFade && <div className="loader"></div>}
          <div className="overlay">
            <CircularProgress />
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default Loading;
